import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton } from '@node-space/ui-components'
import { useWalletContext } from 'hooks/context'

export const CopyAllDetailsCrypto = () => {
  const wallet = useWalletContext()
  const { t } = useTranslation()
  const currencyCodeLabel = t('yourAddress', {
    currencyCode: wallet.currency?.code?.toUpperCase(),
  })

  const copyObject = {
    [currencyCodeLabel]: wallet.address,
    [t('destinationTag')]: wallet.lookup,
  }

  const copyText = Object.keys(copyObject)
    .map((key: string) => `${key}: ${copyObject[key]}`)
    .join('\n')

  return (
    <Box flex centerChildren className="py-6 border-t border-stroke-static">
      <CopyButton copyText={copyText}>{t('copyAllDetails')}</CopyButton>
    </Box>
  )
}
